import store from '../store'

export default [

    {
        path: '*',
        meta: {
            public: true,
        },
        redirect: {
            path: '/404',
        },
    },
    {
        path: '/404',
        meta: {
            public: true,
        },
        name: 'NotFound',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/errors/NotFound.vue'
        ),
    },
    {
        path: '/403',
        meta: {
            public: true,
        },
        name: 'AccessDenied',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/errors/Deny.vue'
        ),
    },
    {
        path: '/500',
        meta: {
            public: true,
        },
        name: 'ServerError',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/errors/Error.vue'
        ),
    },
    {
        path: '/login',
        meta: {
            public: true,
        },
        name: 'Login',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/Login.vue'
        ),
    },
    {
        path: '/',
        meta: {},
        name: 'Root',
        redirect: to => {
            // the function receives the target route as the argument
            // return redirect path/location here.
            if (store.getters['account/currentRole'] == 0) {
                return '/admin/dashboard'
            } else {
                return '/dashboard'
            }
        },
        // redirect: {
        //     name: 'Dashboard'
        // }
    },
    {
        path: '/dashboard',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: 1,
        },
        name: 'Dashboard',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/Dashboard.vue'
        ),
    },
    {
        path: '/search/:search_type/:search_pattern',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Search',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/Search.vue'
        ),
    },
    {
        path: '/admin/dashboard',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'adminDashboard',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/admin/Dashboard.vue'
        ),
    },
    {
        path: '/admin/licence',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Licence',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/admin/Licence.vue'
        ),
    },
    {
        path: '/admin/settings',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Parameters',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/admin/Parameters.vue'
        ),
    },
    {
        path: '/admin/logs',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Logs',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/admin/Logs.vue'
        ),
    },
    {
        path: '/administration/users',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'UserList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/user/UserList.vue'
        ),
    },
    {
        path: '/administration/organization',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Organization',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/organization/Organization.vue'
        ),
    },
    {
        path: '/administration/roles',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'RoleList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/role/RoleList.vue'
        ),
    },
    {
        path: '/administration/delegations',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DelegationList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/delegation/DelegationList.vue'
        ),
    },
    {
        path: '/administration/registered-devices',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'RegisteredDevices',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/registeredDevices/RegisteredDevicesList.vue'
        ),
    },
    {
        path: '/administration/logged-users',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'LoggedUsers',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/user/LoggedUsers.vue'
        ),
    },
    {
        path: '/administration/access-rights',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AccessRightList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/accessRight/AccessRightList.vue'
        ),
    },
    {
        path: '/administration/digital-signatures',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DigitalSignatureList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/digitalSignature/DigitalSignatureList.vue'
        ),
    },
    {
        path: '/administration/content-types',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'ContentTypeList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/contentType/ContentTypeList.vue'
        ),
    },
    {
        path: '/administration/content-type/:id?',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'ContentType',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/contentType/ContentType.vue'
        ),
    },
    {
        path: '/administration/internal-tables',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'InternalTableList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/internalTable/InternalTableList.vue'
        ),
    },
    {
        path: '/administration/flows',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'FlowList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/flow/FlowList.vue'
        ),
    },
    {
        path: '/administration/baskets',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'BasketList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/basket/BasketList.vue'
        ),
    },
    {
        path: '/administration/reports',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'Reports',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/report/Reports.vue'
        ),
    },
    {
        path: '/administration/audits',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'AuditList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/audit/AuditList.vue'
        ),
    },
    {
        path: '/administration/plugins',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'PluginList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/plugin/PluginList.vue'
        ),
    },
    {
        path: '/administration/deleted-documents',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DeletedDocumentList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/deletedDocument/DeletedDocumentList.vue'
        ),
    },
    {
        path: '/administration/locked-documents',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'LockedDocumentList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/lockedDocument/LockedDocumentList.vue'
        ),
    },
    {
        path: '/administration/document-lifecycle',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'DocumentLifecycleList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/documentLifecycle/DocumentLifecycleList.vue'
        ),
    },
    {
        path: '/administration/jobs',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'JobList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/dataManagement/JobList.vue'
        ),
    },
    {
        path: '/administration/connected-services',
        meta: {
            breadcrumb: true,
            requiresAuth: true,
            requiredRole: -1,
        },
        name: 'ConnectedServicesList',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/administration/connectedService/ConnectedServiceList.vue'
        ),
    },
    {
        path: '/restore-device/:user_id/:device_id',
        meta: {
            public: true,
        },
        name: 'Login',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/Login.vue'
        ),
    },
    {
        path: '/external/distribution/:distribution_token',
        meta: {
            public: true,
        },
        name: 'ExternalViewer',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/external/ExternalViewer.vue'
        ),
    },
    {
        path: '/external/redirect/:redirect_token',
        meta: {
            public: true,
        },
        name: 'ExternalRedirect',
        component: () => import(
            /* webpackChunkName: "routes" */
            '@/views/external/ExternalRedirect.vue'
        ),
    }
]
